import React, { Dispatch, Reducer, useContext, useMemo, useReducer } from 'react'

import { Action, ActionType } from './action'

export const initState = {
    phoneNumber: '',
    duration: 0,
    reference: '',
    message: '',
    cid: '',
    user: null as any,
    pdpa: null,
    kycContext: '',
}

const AppStateContext = React.createContext<typeof initState>(initState)
const DispatchStateContext = React.createContext<Dispatch<Action> | undefined>(undefined)

export function useAppState() {
    const context = useContext(AppStateContext)
    if (!context) throw new Error('AppStateContext must be used with AppProvider!')
    return context
}

export function useDispatcher() {
    const context = useContext(DispatchStateContext)
    if (!context) throw new Error('DispatchStateContext must be used with AppProvider!')
    return context
}

const reducer: Reducer<typeof initState, Action> = (state, action) => {
    switch (action.type) {
        case ActionType.SAVED_REFCODE: {
            const { ...props } = action.payload
            return {
                ...state,
                ...props,
            }
        }
        case ActionType.SAVED_USER_INFO: {
            return { ...state, user: action.payload.user }
        }
        case ActionType.PDPA_SUBMITTED: {
            return { ...state, pdpa: { submitted: action.payload || false } }
        }
        case ActionType.SAVED_KYC_CONTEXT_TYPE: {
            return { ...state, kycContext: action.payload }
        }
        default:
            return state
    }
}

export const AppProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initState)
    return (
        <AppStateContext.Provider value={state}>
            <DispatchStateContext.Provider value={dispatch}>
                {useMemo(() => children, [children])}
            </DispatchStateContext.Provider>
        </AppStateContext.Provider>
    )
}
